import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ArticoliCaratTipo, ArticoliCaratTipoLng, ModelNumStr, ModelNumNumStr } from '../../models/-index';
import { Observable, take } from 'rxjs';

@Injectable()
export class ArticoliCaratTipoService extends CrudGenericsService<ArticoliCaratTipo, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ArticoliCaratTipo`);
    this.base = `${env.apiUrl}/api/ArticoliCaratTipo/`;
  }
  GetAllLng(): Observable<ArticoliCaratTipoLng[]> {
    const u = this.base + 'GetAllLng';
    return this.http.get<ArticoliCaratTipoLng[]>(`${u}`);
  }
  Get4TabHead(): Observable<ModelNumNumStr[]> {
    const u = this.base + 'Get4TabHead';
    return this.http.get<ModelNumNumStr[]>(`${u}`);
  }

  SetOrder(model: ModelNumStr[]): Observable<void> {
    const u = `${this.base}SetOrder`;
    return this.http.post<void>(u, model).pipe(take(1));
  }
}
